import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { BellIcon, XIcon } from 'lucide-react';
import { NoticeSignupForm } from './NoticeSignupForm';
interface AlertesDialogProps {
  onClose: () => void;
}
const ease = [0.23, 1, 0.32, 1] as const;

/** Popup d'inscription aux alertes citoyennes, pour un visiteur sans session. */
export function AlertesDialog({
  onClose
}: AlertesDialogProps) {
  const [title, setTitle] = useState('Recevoir les alertes citoyennes');
  useEffect(() => {
    const onKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', onKeyDown);
    const previous = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      window.removeEventListener('keydown', onKeyDown);
      document.body.style.overflow = previous;
    };
  }, [onClose]);
  return <div className="fixed inset-0 z-[110] flex items-end justify-center p-3 sm:items-center sm:p-6" data-id="element-378" data-mp="3opjtxu28lwsx">
      <motion.button type="button" aria-label="Fermer" onClick={onClose} initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} transition={{
      duration: 0.2,
      ease
    }} className="absolute inset-0 h-full w-full cursor-default bg-ville-navy/45 focus:outline-none" data-id="element-379" data-mp="2yf31oy2qxjy4" />

      <motion.div role="dialog" aria-modal="true" aria-labelledby="alertes-dialog-titre" initial={{
      opacity: 0,
      y: 16,
      scale: 0.97
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y: 12,
      scale: 0.98
    }} transition={{
      duration: 0.24,
      ease
    }} className="relative max-h-[90vh] w-full max-w-[520px] overflow-y-auto rounded-3xl border border-slate-200 bg-white p-6 shadow-2xl shadow-ville-navy/20 sm:p-8" data-id="element-380" data-mp="3d5amvlk51h2i">
        <div className="flex items-start justify-between gap-4" data-id="element-381" data-mp="1wqsjou07qcxu">
          <div className="min-w-0" data-id="element-382" data-mp="21p2f95punfjz">
            <span className="grid h-10 w-10 place-items-center rounded-full bg-ville-lime text-ville-navy" aria-hidden="true" data-id="element-383" data-mp="21oarui6eoo4s">
              <BellIcon className="h-5 w-5" data-id="element-384" data-mp="1opbda086szoc" />
            </span>
            <h2 id="alertes-dialog-titre" className="mt-3 text-2xl font-extrabold tracking-tight text-ville-navy" data-id="element-385" data-mp="23l991he78201">
              {title}
            </h2>
          </div>
          <button type="button" onClick={onClose} aria-label="Fermer" className="grid h-9 w-9 shrink-0 place-items-center rounded-full text-slate-500 transition-colors duration-150 ease-ville hover:bg-slate-100 hover:text-ville-navy focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-indigo" data-id="element-386" data-mp="2clp7gcg34iy1">
            <XIcon className="h-5 w-5" aria-hidden="true" data-id="element-387" data-mp="2hf9ytln6aeo9" />
          </button>
        </div>

        <div className="mt-2" data-id="element-388" data-mp="2vam58qaoxtl0">
          <NoticeSignupForm onDone={onClose} onSkip={onClose} onTitleChange={setTitle} data-id="element-389" data-mp="2rbd7zbgfzdkp" />
        </div>
      </motion.div>
    </div>;
}